import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "11",
      cy: "11",
      r: "11",
      fill: "#4E4E4E"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.0011 11.9724L14.85 15.8213L15.8223 14.849L11.9733 11.0001L15.8224 7.15098L14.8502 6.17871L11.0011 10.0278L7.15196 6.17871L6.17969 7.15098L10.0288 11.0001L6.17983 14.849L7.1521 15.8213L11.0011 11.9724Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }